import React from "react";
import { Oval } from "react-loader-spinner";

import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { PaymentMethod } from "../../../../datasource/Stax/models";
import {
  getPaymentMethodsStax,
  setSelectedPaymentMethod,
} from "../../paymentsSlice";

import "./PaymentMethodSelect.scss";

export interface PaymentMethodSelectProps {
  customerId: string;
  onPaymentMethodSelect: (paymentMethod: PaymentMethod) => void;
  onChargeClick: () => void;
  chargeDisabled: boolean;
  chargeLoading: boolean;
  totalToCharge: number;
}

export const PaymentMethodSelect: React.FC<PaymentMethodSelectProps> = ({
  customerId,
  onPaymentMethodSelect,
  onChargeClick,
  chargeDisabled,
  chargeLoading,
  totalToCharge,
}) => {
  const dispatch = useAppDispatch();

  const paymentMethods = useAppSelector(
    (state) => state.payments.paymentMethods
  );
  const selectedPaymentMethod = useAppSelector(
    (state) => state.payments.selectedPaymentMethod
  );
  const getPaymentMethodsAPI = useAppSelector(
    (state) => state.payments.getPaymentMethodsAPI
  );

  React.useEffect(() => {
    if (customerId) {
      dispatch(getPaymentMethodsStax(customerId));
    }
  }, [customerId, dispatch]);

  const handleSelect = (paymentMethod: PaymentMethod) => {
    dispatch(setSelectedPaymentMethod(paymentMethod));
    onPaymentMethodSelect(paymentMethod);
  };

  if (getPaymentMethodsAPI.loading) {
    return (
      <div className="payment-method-select-component">
        <div className="section-label">Payment Methods</div>
        <div className="loading-container">
          <Oval color="#007AFF" height={24} width={24} />
        </div>
      </div>
    );
  }

  return (
    <div className="payment-method-select-component">
      <div className="section-label">Payment Methods</div>

      {paymentMethods.length === 0 ? (
        <div className="no-methods">No saved payment methods found</div>
      ) : (
        <div className="methods-list">
          {paymentMethods.map((method) => (
            <div
              key={method.id}
              className={`method-item ${
                selectedPaymentMethod?.id === method.id ? "selected" : ""
              }`}
              onClick={() => handleSelect(method)}
            >
              <div className="card-icon">
                {getCardIcon(method.cardType)}
              </div>
              <div className="card-details">
                <div className="card-type">{method.cardType}</div>
                <div className="card-number">**** {method.cardLastFour}</div>
              </div>
              <div className="card-exp">Exp: {method.cardExp}</div>
            </div>
          ))}
        </div>
      )}

      <button
        className="charge-button"
        onClick={onChargeClick}
        disabled={chargeDisabled || chargeLoading}
      >
        {chargeLoading ? (
          <Oval color="#fff" height={20} width={20} />
        ) : (
          `Charge Card - $${totalToCharge.toFixed(2)}`
        )}
      </button>
    </div>
  );
};

function getCardIcon(cardType: string): string {
  const type = cardType.toLowerCase();
  if (type.includes("visa")) return "VISA";
  if (type.includes("master")) return "MC";
  if (type.includes("amex") || type.includes("american")) return "AMEX";
  if (type.includes("discover")) return "DISC";
  return "CARD";
}
